import axios from 'axios';
import { EmpresaService } from '../geral';

export default class BoletoService{

    constructor() {

        this.sessionApp = JSON.parse(localStorage.sessionApp);
        const empresaService = new EmpresaService();
        empresaService.ObterPorId(this.sessionApp.empresaId).then(res => {
            this.empresa = res.data;
        });


        this.httpHeader =  {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        };

        this.http = axios.create({
            // baseURL: process.env.NODE_ENV == 'development' ? 'http://localhost:60595/v1/' : 'https://api-boleto.portalongfacil.com.br/v1/',
            baseURL: process.env.VUE_APP_BOLETOAPI,
        });

        // this.http.interceptors.request.use(config => {
    
        //     config.headers.Authorization =  `Basic ${process.env.VUE_APP_ONESIGNAL_TOKEN}`;
            
        //     return config;
        // });

    }

    ReceitaToBoletoModel(receita){
        return {
            codigoBanco: receita.banco.bancoId,
            dataVencimento: receita.dataVencimento,
            valor: receita.valor,
            carteira: receita.banco.carteira,
            nossoNumero: receita.id,
            numeroDocumento: receita.id,
            cedente: {
                codigo: receita.banco.numeroContrato == 0 ? '' : receita.banco.numeroContrato,
                cpfCnpj: this.empresa.cnpjLimpo,
                nome: this.empresa.nome,
                agencia: receita.banco.agenciaLimpo,
                agenciaDigito: receita.banco.agenciaDigitoLimpo,
                conta: receita.banco.contaLimpo,
                contaDigito: receita.banco.contaDigitoLimpo,
                endereco: {
                    endereco: this.empresa.logradouro,
                    bairro: this.empresa.bairro,
                    cidade: this.empresa.cidade,
                    cep: this.empresa.cep,
                    uf: this.empresa.estado
                }
            },
            sacado: {
                cpfCnpj: receita.doador.cpfCnpjLimpo,
                nome: receita.doador.nome,
                endereco: {
                    endereco: `${receita.doador.logradouro} ${receita.doador.numero}`,
                    bairro: receita.doador.bairro,
                    cidade: receita.doador.cidade ? receita.doador.cidade : receita.doador.municipio ? receita.doador.municipio.nome : '',
                    cep: receita.doador.cep,
                    uf: receita.doador.estado
                }
            },
        };
    }

    ReceitaToRemessaModel(receitas, sequencia){
        let boletos = [];
        receitas.forEach(receita => {
            boletos.push(this.ReceitaToBoletoModel(receita));
        });

        const remessaModel = {
            sequencia: sequencia,
            numeroConvenio: receitas[0].banco.numeroContrato ? receitas[0].banco.numeroContrato : '',
            boletos: boletos,
        };

        return remessaModel;
    }

    GerarRemessa(receitas) {

        const remessaModel = this.ReceitaToRemessaModel(receitas, receitas[0].banco.sequenciaRemessa);

        return this.http.post('arquivo/remessa', remessaModel, 
        {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/octet-stream',
              'Access-Control-Allow-Origin': '*'
            }
        });

    }

    ProcessarRetorno(codigoBanco, arquivoRetorno) {

        return this.http.post(`arquivo/retorno/${codigoBanco}`, arquivoRetorno);

    }

    ImprimirPdf(receita) {

        let boletoModel = this.ReceitaToBoletoModel(receita);

        return this.http.post('impressao/pdf', boletoModel, 
        {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf',
              'Access-Control-Allow-Origin': '*'
            }
        });

    }
  
  }